<template>
    <div ref="table" style="margin-top:10px;"></div>

    <!--使用者資料-->
    <OutletUserInfo ref="outletuserRef" @finish="onLoadTable(searchForm)"></OutletUserInfo>
</template>

<script setup>
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ref, reactive, onMounted, defineExpose } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus'
    import OutletUserInfo from '@/components/OutletUserInfo.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const outletuserRef = ref(null);

    const table = ref(null);
    const tabulator = ref(null);

    const formData = ref(null);

    const searchForm = ref({
        COMP_ID: ''
    });

    const onSearch = (data) => {
        searchForm.value.COMP_ID = data;
        onLoadTable();
    }

    const onLoadTable = () => {
        $api.GET('/api/OutletUser/GetTableData', searchForm.value.COMP_ID
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    // 讓父用子方法
    defineExpose({ onSearch });

    const onEditClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));
        outletuserRef.value.onEditClick(searchForm.value.COMP_ID, formData.value);
    }

    const onDeleteClick = (e, cell) => {
        ElMessageBox.confirm('確定要刪除?', '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            $api.POST('/api/OutletUser/Delete',
               cell.getData(),
            ).then((res) => {
                ElMessageBox.alert('刪除成功!', '提示', {
                    confirmButtonText: '確定',
                   callback: action => {
                        onLoadTable();
                    }
                });
            }).catch((error) => {
                ElMessageBox.alert('刪除失敗!', '提示', {
                    confirmButtonText: '確定'
                });
            });
        });
    }

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }

    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64h256zm64 0h192v-64H416v64zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32H192zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32zm192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32z"></path></svg></i>';
    }

    onMounted(() => {
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "100%", //do not let table get bigger than the height of its parent element
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            dataTree: true,
            dataTreeStartExpanded: true,
            initialSort: [             //set the initial sort order of the data
                { column: "USER_CODE", dir: "asc" },
            ],
            columns: [                 //define the table columns
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "登入帳號", field: "USER_CODE", headerHozAlign: "center", hozAlign: "center" },
                { title: "使用者姓名", field: "USER_NAME", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "電子郵件", field: "EMAIL", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "連絡電話", field: "TEL_NO", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "啟用", field: "ACCT_ENABLE", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "密碼到期日", field: "PWD_EXPIRY_DATE", width: 100, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "編輯", field: "edit", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter:editIcon, cellClick: onEditClick },
                { title: "刪除", field: "delete", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: deleteIcon, cellClick: onDeleteClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });

        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });
    })
</script>